import { usePathname, useRouter, useSearchParams } from 'next/navigation';

const useQueryString = () => {
  const searchParamsObject: Record<string, string | number> = {};

  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  searchParams.forEach((value, key) => {
    searchParamsObject[key] = value;
  });

  const setQueryString = (queryString: Record<string, string | number | number[]>) => {
    const params = new URLSearchParams();
    
    // Thêm tất cả các tham số vào URLSearchParams
    Object.entries(queryString).forEach(([key, value]) => {
      if (value === undefined || value === null || value === '') {
        return; // Bỏ qua tham số rỗng
      }
      
      if (Array.isArray(value)) {
        value.forEach(item => {
          params.append(key, item.toString());
        });
      } else {
        params.append(key, value.toString());
      }
    });
    
    const queryStr = params.toString();
    const url = `${pathname}${queryStr ? `?${queryStr}` : ''}`;
    
    console.log('Final URL:', url);
    router.push(url);
  };

  const resetQueryString = () => {
    router.push(pathname);
  };

  return {
    queryString: searchParamsObject,
    setQueryString,
    resetQueryString,
  };
};

export default useQueryString;
